// extracted by mini-css-extract-plugin
export default {"desktopTitleMedium":"App_desktopTitleMedium__QHeOq","mobileHeadlineLarge":"App_mobileHeadlineLarge__fauxl","app":"App_app__GuJBs","content":"App_content__naSmy"};